/**
 * Sesión vencida (Sol 28/09/2026): un 401 de la API no es un dato roto.
 *
 * Amplify renueva el ID token solo mientras el refresh token está vivo; cuando
 * vence (o la persona cerró sesión en otra pestaña), `fetchAuthSession()` vuelve
 * sin token, la API responde UNAUTHORIZED "Authentication required" y cada
 * pantalla lo pintaba como si SU dato hubiera fallado (la tab Hiring Plan de TA
 * decía "la descarga de la base falló"). Acá el 401 se convierte en un solo
 * evento global: el layout avisa "tu sesión venció" y manda al login.
 *
 * Se usa como `fetch` de los links de tRPC y de las Function URLs (ta-api).
 */
export const SESSION_EXPIRED_EVENT = 'internal:session-expired';

let lastNotified = 0;

/** Un aviso cada 30 s como mucho: un batch con 5 queries vencidas es UN aviso. */
export function notifySessionExpired(): void {
  const now = Date.now();
  if (now - lastNotified < 30_000) return;
  lastNotified = now;
  window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
}

/** `fetch` que avisa la sesión vencida ante un 401 y devuelve la respuesta tal cual. */
export const fetchWithSessionGuard: typeof fetch = async (input, init) => {
  const res = await fetch(input, init);
  if (res.status === 401) notifySessionExpired();
  return res;
};
